import React, { useState, useEffect } from "react";
import { Typography, Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import { useTranslation } from "react-i18next";
import LoanReceivedIcon from "../../assets/Icon/LoanRecievedIcon.png";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate } from "react-router-dom";
import CustomCard from "../../components/Famer/GenericCard";
import CustomTabs from "../../components/Custom/CustomTabs";
export default function LoanProposals() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    api
      .get("/lending/list-loan-requests/")
      .then((response) => {
        setProposals(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
      });
  }, []);

  const handleClickNavigate = (propalId, loan_request_id) => {
    navigate(
      `/fpo/view-loan-proposal/${propalId}?loan-request-id=${loan_request_id}`
    );
  };
  const handleRequestNavigate = (loan_request_id) => {
    navigate(`/fpo/view-loan-proposal/${loan_request_id}`);
  };

  const receivedProposals =
    proposals.loan_proposals?.filter(
      (proposal) => proposal.borrower_status === "pending"
    ) || [];

  const requestedProposals =
    proposals.loan_requests?.filter(
      (proposal) => proposal.lender_status === "pending"
    ) || [];

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}></LoaderContainer>
      <Container
        maxWidth="xs"
        style={{
          height: "94vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 2,
            fontSize: "30px",
            fontWeight: 700,
            marginTop: "10px",
          }}
        >
          {t("My Proposals")}
        </Typography>

        <CustomTabs
          numTabs={2}
          tabTitles={[t("Received"), t("Requested")]}
          counts={[receivedProposals.length, requestedProposals.length]}
          onTabChange={setTabValue}
        />

        {tabValue === 0 && (
          <div style={{ height: "90%" }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {receivedProposals.map((proposal) => (
                  <CustomCard
                    key={proposal.id}
                    id={proposal.id}
                    loan_request_id={proposal.loan_request}
                    t={t}
                    data={{
                      [t("Name")]: proposal.lender_name,
                      [t("Interest Rate")]: proposal.rate,
                      [t("Loan Amount")]: proposal.amount,
                      [t("Loan Type")]: proposal.loan_type,
                    }}
                    loanData={true}
                    clickable={true}
                    handleClickNavigate={handleClickNavigate}
                  />
                ))}
              </Grid>
            </Grid>
          </div>
        )}

        {tabValue === 1 && (
          <div style={{ height: "90%" }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {requestedProposals.map((proposal) => (
                  <CustomCard
                    key={proposal.id}
                    id={proposal.id}
                    loan_request_id={proposal.id}
                    t={t}
                    data={{
                      [t("Name")]: proposal.lender_onboard.lender_name,
                      [t(
                        "Interest Rate"
                      )]: `${proposal.lender_onboard.interest_rate_min}- ${proposal.lender_onboard.interest_rate_max}`,
                      [t(
                        "Loan Amount"
                      )]: `Up To Rs.${proposal.lender_onboard.loan_amount}`,
                      [t("Loan Tenure")]:
                        proposal.lender_onboard.loan_tenure_months,
                    }}
                    clickable={true}
                    handleClickNavigate={handleRequestNavigate}
                  />
                ))}
              </Grid>
            </Grid>
          </div>
        )}

        {proposals.length === 0 && (
          <div
            style={{
              height: "90%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                margin: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={LoanReceivedIcon}
                alt="No Commodity Available"
                style={{
                  width: "127px",
                  height: "127px",
                  marginBottom: "10px",
                }}
              />

              <Typography
                variant="subtitle1"
                sx={{ mb: 2, textAlign: "center" }}
              >
                {t("Your Proposals will be shown here")}
              </Typography>
            </div>
          </div>
        )}

        <CustomButton onClick={() => navigate("/fpo/loans")}>
          {t("Back")}
        </CustomButton>
      </Container>
    </>
  );
}
